import React, { useEffect } from 'react';
import '../styles/nodeInfo.css';
import { useState } from 'react';
import { getDefinition } from '../utility/api';
import { Loader } from './Loader';

function NodeInfo({selectedNodeId, selectedNodeChain, data }) {

  const [currentDef, setCurrentDef] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [currentHeading, setCurrentHeading] = useState(null);

  useEffect(() => {
    if (selectedNodeId === null) {
      return;
    }

    if (isLoading) {
      return;
    }

    if (data === null || data === undefined) {
      return;
    }

    var selectedNode = data.nodes.find(n => n.id === selectedNodeId);

    if (selectedNode === null || selectedNode === undefined) {
      return;
    }

    setCurrentHeading(selectedNode.name);
    setIsLoading(true);

    getDefinition(selectedNodeChain, selectedNode.id, getRootNodeID(data))
      .then(d => {
        setCurrentDef(d);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }
  , [selectedNodeId]);

  return (
    <div className="NodeInfo">
      <div className='nodeInfo-heading'>
        {currentHeading}</div>
      <div className='def'>
        {isLoading ? <Loader isLoading={isLoading} /> : <div>{currentDef}</div>}
      </div>
    </div>
  );
}

function getRootNodeID(data) {
  if (data === null || data === undefined) {
    return null;
  }

  var rootNode = data.nodes.find(n => n.group === 0);
  if (rootNode === null || rootNode === undefined) {
    return null;
  }

  return rootNode.id;
}

export default NodeInfo;
